// extracted by mini-css-extract-plugin
export default {"button":"toggle_button__mtgqD","thumb":"toggle_thumb__ijgOo"};